export default __webpack_public_path__ + "static/08-the-latam-mobile-ca839fbec78b19452892e6fad66654f3.svg";